export { DrugsList } from './DrugsList.component';
